// extracted by mini-css-extract-plugin
export default {"wrapper":"SignUpPage_wrapper__-iD8h","form-input":"SignUpPage_form-input__LOgtU","nort-section":"SignUpPage_nort-section__tkzIN"};